<template>
  <div class="ibox-content">
    <div class="row mt-4">
      <div class="col-md-12">
        <strong>
          {{infoTotalModels}}
        </strong>
      </div>
    </div>

    <!-- Table -->
    <div class="row flex-fill d-flex justify-content-start">
      <div class="col-md-12 mt-2">
        <table class="table table-borderless table-border table-align">
          <thead>
            <tr>
              <th>Placa</th>
              <th>Renavam</th>
              <th>Status</th>
              <th>Valor</th>
              <th>Valor a pagar</th>
              <th>Data de vencimento</th>
              <th>Órgão consultado</th>
              <th>Atualizado em</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="history in feeHistories" :key="history.id">
              <td>{{ history.plate }}</td>
              <td>{{ history.renavam }}</td>
              <td>{{ translateStatus(history.status) }}</td>
              <td>{{ history.valueCents | price }}</td>
              <td>{{ history.finalValueCents | price }}</td>
              <td>{{ history.expiredAt | datetime }}</td>
              <td>{{ translateAuthority(history.consultedAuthority) }}</td>
              <td>{{ history.updatedAt | datetime }}</td>
              <td>
                <button v-if="isSuperUser" class="btn btn-primary" @click="showDetails(history)">
                  Detalhes
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <Modal v-model="showModal" v-if="currentFeeHistory">
      <pre><small><code>{{ currentFeeHistory }}</code></small></pre>
    </Modal>

  </div>
</template>
<script>

import ModelMapper from '@/mixins/ModelMapper'
import Modal from '../shares/specialTag/Modal.vue'
import GetUser from '@/mixins/GetUser'
import { IssuingAuthority } from '@/models/IssuingAuthority';

export default {
  components: { Modal },
  computed: {
    feeHistories() {
      return this.getModels || []
    },
  },
  created() {
    this.addOrderBy('createdAt')

    this.asyncTemplateSelect({
      byURL: true,
      pagination: true,
    })
  },
  data: () => ({
    currentFeeHistory: null,
    modelPathPrefix: 'maestro',
    nameModel: 'FeeHistories',
    showModal: false,
    feeId: null,
  }),
  methods: {
    buildPath() {
      return `maestro/fees/${this.fee.id}/histories`
    },
    showDetails(feeHistory) {
      this.currentFeeHistory = feeHistory
      this.showModal = true
    },
    translateStatus(value) {
      return {
        expired: 'Vencido',
        opened: 'Em aberto',
        undefined: 'Indefinido',
        paid: 'Pago',
      }[value] || value
    },
    translateAuthority(value) {
      return IssuingAuthority.label(value)
    },
  },
  mixins: [ModelMapper, GetUser],
  name: 'FeeHistories',
  props: {
    fee: {
      required: true,
      type: Object,
    }
  }
}

</script>

<style scoped>

</style>